<template>
  <div id="basica_servicio_externo">
    <div v-if="loading" class="text-center">
      <div class="loadingio-spinner-ripple-6armq16mc04">
        <div class="ldio-2tzb8vdk7pu">
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        v-if="servicio_externo.estado_servicio == 0"
        class="text-warning fw-bold mt-2 mb-4"
      >
        <i class="fa fa-info-circle"></i> Este servicio se encuentra inactivo.
      </div>
      <h4 class="mb-4 fw-bold text-info">Información básica</h4>
      <div v-if="permiso">
        <div class="row">
          <div class="col-lg-12 col-12 form-group">
            <label>Nombre del servicio externo</label>
            <input
              v-model="servicio_externo.servicio"
              type="text"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label>Proveedor</label>
            <v-select
              v-model="servicio_externo.proveedor"
              @input="proveedores = []"
              @search="get_proveedores"
              label="proveedor"
              :options="proveedores"
              :clearable="true"
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  No se encontraron resultados para
                  <em>{{ search }}</em
                  >.
                </template>
                <em v-else style="opacity: 0.5"
                  >Empieza a escribir el nombre del proveedor</em
                >
              </template>
            </v-select>
          </div>

          <div class="col-lg-12 form-group">
            <label>Destino</label>
            <v-select
              v-model="servicio_externo.destino"
              @search="get_ciudades"
              label="ciudad_pais"
              :options="destinos"
              :clearable="false"
            ></v-select>
          </div>

          <div class="col-lg-12 form-group">
            <label>Incluye</label>
            <editor
              v-model="servicio_externo.incluye"
              :api-key="editor.api_key"
              :init="editor.init"
            />
          </div>

          <div class="form-group col-lg-6">
            <label>Tarifa de neta adultos </label>
            <money
              v-model="servicio_externo.tarifa_neta_adultos"
              class="form-control text-end"
              v-bind="money"
              required
            ></money>
          </div>

          <div class="form-group col-lg-6">
            <label>Tarifa de venta adultos </label>
            <money
              v-model="servicio_externo.tarifa_venta_adultos"
              class="form-control text-end"
              v-bind="money"
              required
            ></money>
          </div>

          <div class="form-group col-lg-6">
            <label>Tarifa de neta niños </label>
            <money
              v-model="servicio_externo.tarifa_neta_ninos"
              class="form-control text-end"
              v-bind="money"
              required
            ></money>
          </div>

          <div class="form-group col-lg-6">
            <label>Tarifa de venta niños </label>
            <money
              v-model="servicio_externo.tarifa_venta_ninos"
              class="form-control text-end"
              v-bind="money"
              required
            ></money>
          </div>

          <div class="col-lg-4 form-group">
            <label>Estado</label>
            <select
              v-model="servicio_externo.estado_servicio"
              class="form-control"
            >
              <option value="0">Inactivo</option>
              <option value="1">Activo</option>
            </select>
          </div>
        </div>

        <div class="text-end">
          <button
            v-on:click="update_servicio_externo"
            class="btn btn-success btn-sm"
          >
            <i class="fa fa-save"></i> Guardar cambios
          </button>
          <button
            v-on:click="delete_servicio_externo"
            class="btn btn-outline-danger btn-sm ms-1"
          >
            <i class="fa fa-trash"></i> Eliminar servicio
          </button>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-lg-12 col-12 form-group">
            <label>Nombre del servicio externo</label>
            <h6>{{ servicio_externo.servicio }}</h6>
          </div>
          <div class="col-lg-12 form-group">
            <label>Incluye</label>
            <p v-html="servicio_externo.incluye"></p>
          </div>
          <div class="col-lg-4 form-group">
            <label>Estado</label>
            <p>
              <span v-if="servicio_externo.estado_servicio == 0">Inactivo</span>
              <span v-if="servicio_externo.estado_servicio == 1">Activo</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
import Editor from "@tinymce/tinymce-vue";
export default {
  name: "Basica_servicio_externo",
  metaInfo: {
    title: "Información básica de servicio externo - Backoffice",
  },
  components: {
    editor: Editor,
  },
  data() {
    return {
      loading: true,
      editor: {
        api_key: this.$editor_api_key,
        init: {
          height: 200,
          menubar: false,
          toolbar: "undo redo  | bold italic  |  bullist numlist  | ",
          plugins: "lists advlist",
        },
      },
      id_servicio: null,
      destinos: [],
      proveedores: [],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "$ ",
        suffix: "",
        precision: 0,
        masked: false,
      },
    };
  },
  props: {
    session: Object,
    servicio_externo: Object,
    permiso: Boolean,
  },
  created: function () {
    this.id_servicio = this.$route.params.id_servicio;
    this.get_proveedores();
  },
  methods: {
    update_servicio_externo: function () {
      const vm = this;
      vm.loading = true;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        Token: vm.session.usuario.token_session,
      };
      let params = {
        id_servicio: this.id_servicio,
        servicio_externo: this.servicio_externo,
      };
      axios
        .post(this.$base_url + "servicios/update_servicio_externo", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Servicio Externo",
              text: response.data.message,
            });
            vm.loading = false;
          } else {
            vm.$notify({
              group: "foo",
              type: "success",
              title: "Servicio Externo",
              text: response.data.message,
            });
            vm.loading = false;
          }
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Servicio Externo",
            text: error,
          });
        })
        .finally();
    },
    delete_servicio_externo: function () {
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        Token: vm.session.usuario.token_session,
      };
      let params = {
        id_servicio: this.id_servicio,
      };
      axios
        .post(this.$base_url + "servicios/delete_servicio", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Servicio Externo",
              text: response.data.message,
            });
          } else {
            vm.$notify({
              group: "foo",
              type: "success",
              title: "Servicio Externo",
              text: response.data.message,
            });
          }
          this.$router.push("/servicios_externos/1");
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Servicio Externo",
            text: error,
          });
        })
        .finally();
    },
    get_ciudades: function (search) {
      if (search.length < 3) {
        return false;
      }
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": vm.$api_key,
      };
      let config = {
        headers: headers,
        params: {
          search: search,
        },
      };
      axios
        .get(vm.$base_url + "destinos/ciudades", config, {
          headers: headers,
        })
        .then((response) => {
          if (response.data.status) {
            vm.destinos = response.data.data.ciudades;
          } else {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Servicios externos",
              text: response.data.message,
            });
          }
          vm.loading = false;
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Servicios externos",
            text: error,
          });
          vm.loading = false;
        });
    },
    get_proveedores: function () {
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": vm.$api_key,
      };
      let config = {
        headers: headers,
        params: {
          estado: 1,
        },
      };
      axios
        .get(vm.$base_url + "proveedores/proveedores", config, {
          headers: headers,
        })
        .then((response) => {
          if (response.data.status) {
            vm.proveedores = response.data.data.proveedores;
          } else {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Actividades",
              text: response.data.message,
            });
          }
          vm.loading = false;
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Actividades",
            text: error,
          });
          vm.loading = false;
        });
    },
  },
  mounted: function () {
    this.loading = false;
  },
};
</script>
